/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const INTERNAL_LABEL_VARIANTS = ['alt', 'floating'];
export const EXTERNAL_LABEL_VARIANTS = ['left-label', 'top-label'];
